import type { Account } from "../api/types";
import { isPaperAccount } from "../lib/account";

export function ConnectionPill({ account }: { account: Account }) {
  // Paper/monitor accounts have no broker session — "disconnected" would read
  // as a fault, so show an intentional "paper" pill instead.
  if (isPaperAccount(account))
    return (
      <span className="pill dim" title="Monitor-only paper account — no broker session">
        paper
      </span>
    );

  // Tradovate-backed prop firm accounts
  if (account.broker === "tradovate") {
    const ts = account.tradovate?.status ?? "";
    const lastError = account.tradovate?.last_error ?? null;
    if (ts === "connected") return <span className="pill good">connected</span>;
    if (ts === "pending") return <span className="pill warn">connecting</span>;
    if (ts === "error" || lastError)
      return <span className="pill bad" title={lastError ?? ""}>error</span>;
    return <span className="pill dim">disconnected</span>;
  }

  // Rithmic-backed cash accounts
  const s = account.rithmic?.status ?? "";
  const lastError = account.rithmic?.last_error ?? null;
  if (s === "connected") return <span className="pill good">connected</span>;
  if (s === "pending") return <span className="pill warn">connecting</span>;
  if (s === "error" || lastError)
    return <span className="pill bad" title={lastError ?? ""}>error</span>;
  return <span className="pill dim">disconnected</span>;
}
